export interface DocumentValidationExceptionI {
  propertyPaths: string[];
  translatedMessage: string;
}

export function isDocumentValidationException(err: unknown): err is DocumentValidationExceptionI[] {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return err && Array.isArray(err) && err.length > 0 && typeof err[0]?.translatedMessage === 'string';
}

export function concatenateDocumentValidationExceptionHtml(val: DocumentValidationExceptionI[]): string {
  return val.reduce((finalMsg, el, currentIndex) => finalMsg + el.translatedMessage + (currentIndex === val.length - 1 ? '' : '<p></p>'), '');
}
